// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","title":"App_title__YS7Xx"};